module.exports = __webpack_public_path__ + "img/experiences_B Kids take the field.604d261c.jpg";